import './App.css';
import DocumentDiff from './pages/document-diff';
import Collections from './pages/collections';
import Collection from './pages/collection';
import { Provider } from 'react-redux'
import store from './redux/store'
import theme from "./theme";
import { createBrowserRouter, RouterProvider, createRoutesFromElements, Route, Redirect, Navigate } from "react-router-dom";
import Document from './pages/document';
import UserContext from './state/UserContext';
import AppContext from './state/AppContext';
import { ThemeProvider } from '@mui/material';
import ScreenDebug from './template/ScreenDebug';
import { useEffect, useState } from 'react';
import { Toaster } from 'react-hot-toast';
import Diff from './pages/diff';
import Template from './template/Template';
import EditCollection from './pages/edit-collection';
import EditUser from './pages/edit-user';
import Users from './pages/users';
import Login from './pages/login';
import EditProject from './pages/edit-project/EditProject';
import EditToken from './pages/edit-token';
import APIInvoke from './utils/APIInvoke';
import Restore from './pages/restore';
import Profile from './pages/profile/Profile';
import GrantContent from './template/GrantContent';
import * as Permissions from './utils/Permissions'
import Home from './pages/home/Home';
import AppMonitoring from './pages/app-monitoring/AppMonitoring';
import EditAppMonitor from './pages/edit-app-monitor';
import CollectionsAlerts from './pages/collections-alerts';
import TLog from './pages/tlog/TLog';
import Auditlogs from './pages/auditlogs/Auditlogs';
import AuditlogDetail from './pages/auditlog-detail/AuditLogDetail';
import { SANDBOX_SET_STATE } from './redux/redux-const';
import Incidents from './pages/incidents';
import EditIncident from './pages/edit-incident';
import Webhooks from './pages/webhooks';
import EditWebhook from './pages/edit-webhook';
import Welcome from './pages/welcome';
import EditCollectionIndex from './pages/edit-collection/EditCollectionIndex';
import EditCollectionRule from './pages/edit-collection/EditCollectionRule';
import DashboardPage from './pages/dashboard/DashboardPage';
import HighFrequencyAlerts from './pages/high-frequency-alerts/HighFrequencyAlerts';
import Secrets from './pages/secrets';
import EditSecret from './pages/edit-secret';
import DocumentTransaction from './pages/document-transaction/DocumentTransaction';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path='/' >
      <Route path="login" element={<Login />} />
      <Route path="restore" element={<Restore />} />
      <Route element={<Template />}>
        <Route path="/" element={<Home />} />
        <Route path="profile" element={<Profile />} />
        <Route path="projects/:project" element={<Welcome />} />
        <Route path="projects/:project/dashboard" element={<GrantContent permisos={[Permissions.DASHBOARD_R]} isPage={false}>
          {(canAccess, roles, permisos, isPage) => {
            if(canAccess) {
              return <DashboardPage />
            } else {
              return <Welcome />
            }
          }}
        </GrantContent>} />
        
        <Route path="projects/:project/edit" element={<GrantContent permisos={[Permissions.PROJECTS_W]} isPage={true}children={<EditProject />} />} />
        <Route path="projects/:project/tokens/new" element={<GrantContent permisos={[Permissions.PROJECTS_TOKENS_W]} isPage={true}children={<EditToken />} />} />
        <Route path="projects/:project/collections" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<Collections />} />} />
        <Route path="projects/:project/collections/notifications" element={<GrantContent permisos={[Permissions.DOCUMENTS_R]} isPage={true} children={<CollectionsAlerts />} />} />
        <Route path="projects/:project/collections/:collection" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<Collection />} />} />
        <Route path="projects/:project/collections/:collection/edit" element={<GrantContent permisos={[Permissions.COLLECTIONS_W]} isPage={true}  children={<EditCollection />} />} />
        <Route path="projects/:project/collections/:collection/documents/:documentId" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<Document />} />} />
        <Route path="projects/:project/collections/:collection/documents/:documentId/diff" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<Diff />} />} />
        <Route path="projects/:project/collections/:collection/indexes/new" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<EditCollectionIndex />} />} />
        <Route path="projects/:project/collections/:collection/indexes/:indexId" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<EditCollectionIndex />} />} />
        <Route path="projects/:project/collections/:collection/rules/new" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<EditCollectionRule />} />} />
        <Route path="projects/:project/collections/:collection/rules/:ruleId" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<EditCollectionRule />} />} />
        
        <Route path="projects/:project/documents/:documentId/diff" element={<GrantContent permisos={[Permissions.COLLECTIONS_R]} isPage={true} children={<DocumentDiff />} />} />

        <Route path="projects/:project/monitoring/apps" element={<GrantContent permisos={[Permissions.APP_MONITORING_R]} isPage={true} children={<AppMonitoring />} />} />
        <Route path="projects/:project/monitoring/apps/new" element={<GrantContent permisos={[Permissions.APP_MONITORING_R]} isPage={true} children={<EditAppMonitor />} />} />
        <Route path="projects/:project/monitoring/apps/:appMonitorId/edit" element={<GrantContent permisos={[Permissions.APP_MONITORING_R]} isPage={true} children={<EditAppMonitor />} />} />

        <Route path="users" element={<GrantContent permisos={[Permissions.USERS_R]} isPage={true} children={<Users />} />} />
        <Route path="users/:user/edit" element={<GrantContent permisos={[Permissions.USERS_W]} isPage={true} children={<EditUser />} />} />

        <Route path="projects/:project/auditlogs" element={<GrantContent permisos={[Permissions.AUDITLOGS_R]} isPage={true} children={<Auditlogs />} />} />
        <Route path="projects/:project/auditlogs/:auditlogId" element={<GrantContent permisos={[Permissions.AUDITLOGS_R]} isPage={true} children={<AuditlogDetail />} />} />

        <Route path="projects/:project/tlogs/:traceId" element={<GrantContent permisos={[Permissions.TRANSACTIONAL_LOGS_R]} isPage={true} children={<TLog />} />} />


        <Route path="projects/:project/incidents" element={<GrantContent permisos={[Permissions.INCIDENTS_R]} isPage={true} children={<Incidents />} />} />
        <Route path="projects/:project/incidents/new" element={<GrantContent permisos={[Permissions.INCIDENTS_W]} isPage={true} children={<EditIncident />} />} />
        <Route path="projects/:project/incidents/:incidentId/edit" element={<GrantContent permisos={[Permissions.INCIDENTS_W]} isPage={true} children={<EditIncident />} />} />

        <Route path="projects/:project/webhooks" element={<GrantContent permisos={[Permissions.WEBHOOKS_R]} isPage={true} children={<Webhooks />} />} /> 
        <Route path="projects/:project/webhooks/:webhookId" element={<GrantContent permisos={[Permissions.WEBHOOKS_W]} isPage={true} children={<EditWebhook />} />} />
        <Route path="projects/:project/webhooks/new" element={<GrantContent permisos={[Permissions.WEBHOOKS_W]} isPage={true} children={<EditWebhook />} />} />
        <Route path="projects/:project/webhooks/:webhookId/edit" element={<GrantContent permisos={[Permissions.WEBHOOKS_W]} isPage={true} children={<EditWebhook />} />} />


        <Route path="projects/:project/high-frequency-alerts" element={<GrantContent permisos={[Permissions.HIGH_FREQUENCY_ALERTS_R]} isPage={true} children={<HighFrequencyAlerts />} />} />
        

        <Route path="projects/:project/secrets" element={<GrantContent permisos={[Permissions.SECRETS_R]} isPage={true} children={<Secrets />} />} />
        <Route path="projects/:project/secrets/:secret/edit" element={<GrantContent permisos={[Permissions.SECRETS_W]} isPage={true} children={<EditSecret />} />} />

        <Route path="projects/:project/documents/transactions/:transactionId" element={<GrantContent permisos={[Permissions.DOCUMENTS_R]} isPage={true} children={<DocumentTransaction />} />} />

        {/* 
        <Route path="projects/:project/webhooks" element={
          <GrantContent permisos={[Permissions.INCIDENTS_R]}>
            <Webhooks />
          </GrantContent>
        } />
        */}

      </Route>
    </Route>
  )
);


function App() {

  const [user, setUser] = useState({
  });

  const [appContext, setAppContext] = useState({
    template: {
      width: 320
    },
    navbar: {
      open: window.innerWidth >= 1024 ? true : false,
    },
    taskbar: {
      open: false
    },
    loading: false,
    projects: [],
    project: ""
  });

  const [isReady, setReady] = useState(false);

  useEffect(() => {
    init()
  }, [])

  useEffect(() => {
    if(isReady && user.id !== undefined) {
      loadContext()
    }
  }, [isReady])  

  const loadContext = async () => {
    const rawResponse = await APIInvoke.invokeGET(`/projects/${appContext.project}/sandbox`)
    const response = await rawResponse.json()
    if(response.ok) {
      store.dispatch({ type: SANDBOX_SET_STATE, payload: { docReferences: response.body.docReferences }  })
    } 
  }

  const init = async () => {
    try {
      const token = window.localStorage.getItem("token")
      if (token) isTokenExpired(token)
      if (token) {
        const loginResponse = await (await APIInvoke.invokePOST(`/users/login`)).json()
        const body = loginResponse.body

        //const projectResponse = await (await APIInvoke.invokeGET(`/projects`)).json()
        const projects = loginResponse.body.projects

        //setProjects(projectResponse.body.items)

        if (loginResponse.ok) {
          window.localStorage.setItem("token", body.token);
          setUser({
            ...body.user,
            roles: body.roles,
            permissions: body.permissions
          })

          let defaultProject = null
          const location = window.location.pathname.split("/")
          if (location.length >= 3 && location[1] === 'projects' && location[2] !== '_new') {
            defaultProject = projects.find(x => x.name === location[2].trim())
          } else if (projects.length > 0) {
            defaultProject = projects.find(x => x.name === loginResponse.body.user.settings?.defaultProject)
            if (!defaultProject) {
              defaultProject = projects[0]
            }
          }

          setAppContext({
            ...appContext,
            projects: projects,
            selectedProject: defaultProject,
            project: defaultProject?.name
          })

          /*
          if (projects.length === 0) {
            console.log("window.location.pathname", window.location.pathname)
            if (window.location.pathname !== '/projects/_new/edit') {
              window.location = "/projects/_new/edit"
              return;
            }
          }
          */
        } else {
          window.localStorage.removeItem("token")
          window.location = "/login"
        }
      }
    } catch (error) {
      console.error(error)
    } finally {
      setReady(true)
    }
  }

  const isTokenExpired = (token) => {
    const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
    const isExpity = (Math.floor((new Date()).getTime() / 1000)) >= expiry;
    if (isExpity) {
      window.localStorage.removeItem("token")
      window.location = "/login"
    }
  }

  return (
    <UserContext.Provider value={{ user, setUser }}>
      <AppContext.Provider value={{ appContext, setAppContext }}>
        <Provider store={store}>
          <ThemeProvider theme={theme}>
            <ScreenDebug />
            <Toaster position="bottom-center" reverseOrder={false} toastOptions={{ duration: 5000, sticky: true, style: { padding: "16px" }, error: { style: { background: "#FAA0A0" } }, success: { style: { background: "#ECFFDC" } } }} />
            {isReady && (
              <RouterProvider router={router} />
            )}
          </ThemeProvider>
        </Provider>
      </AppContext.Provider>
    </UserContext.Provider>
  )
}

export default App;
